import React from "react";
import { Creatable } from "react-select";
import "react-select/dist/react-select.css";
import SearchIcon from "../../../../Layout/Icons/SearchIcon";
import FeaturedCategories from "./FeaturedCategories";
import SearchResults from "./SearchResults";
import AutoComplete from "./AutoComplete";

class ClipartCollection extends React.Component {
  state = {
    selectValue: null,
    selectedOption: "",
    selectedClipartId: null,
    showAll: false,
  };

  // Update the state to added a 'selected' class to the proper clipart element
  setSelectedClipartId = (selectedId) => {
    this.setState({
      selectedClipartId: selectedId,
    });
  };

  handleSubmitSelection = (selectValue) => {

    let selectLabel = selectValue;
    // Update the state to the search value on submit
    if (!isNaN(selectValue)){
      let currOption = this.props.categoriesList.find(
        (option) => (
          option.value === selectValue
        )
      );
      selectLabel = currOption ? currOption.label : '';
    }

    this.setState({ selectedOption: selectValue });
    this.setState({ selectValue: selectLabel });
    this.setState({ showAll: false });
  };

  clearSearch = () => {
    this.setState({
      selectValue: '',
      selectedOption: "",
      showAll: false,
    });
  };

  showAllClipart = () => {
    this.setState({
      selectValue: '',
      selectedOption: "",
      showAll: true,
    });
  };

  render() {
    const searchValue = this.state.selectedOption;

    return (
      <div className="tool tool--search search-container">
        <div className="clipart-search-wrapper">
          <AutoComplete
            layerId = {this.props.layerId}
            selectValue = {this.state.selectValue}
            options = {this.props.categoriesList.filter(filterCategoryByUser, this.props)}
            handleSubmitSelection = {this.handleSubmitSelection}
          />

          <div className="search-icon">
            <SearchIcon />
          </div>
        </div>

        {(this.state.selectValue || this.state.showAll) && (
          <button
            className="tool--search__clear button button--round"
            onClick={this.clearSearch}
          >
            Clear search
          </button>
        )}

        <FeaturedCategories
          categoriesList={this.props.categoriesList}
          handleSubmitSelection={this.handleSubmitSelection}
          handleShowAll={this.showAllClipart}
          searchValue={searchValue || "629"}
          showAll={this.state.showAll}
        />

        <SearchResults
          searchValue={searchValue}
          cliparts={this.props.cliparts}
          categoriesList={this.props.categoriesList}
          selectValue={this.state.selectValue}
          layerId={this.props.layerId}
          setSelectedClipartId={this.setSelectedClipartId}
          selectedClipartId={this.state.selectedClipartId}
          onChooseClipart={this.props.onChooseClipart}
          defaultImageSize={this.props.defaultImageSize}
          showAll={this.state.showAll}
          user={this.props.user}
        />
      </div>
    );
  }
}

function filterCategoryByUser(category){
  // Include any cateogry that doesn't have a defined user, if a user is defined check that the logged in user is defined on the category
  if (category.userId.length > 0 && (category.userId.indexOf(this.user.id.toString()) == -1)){
    return false;
  }
  return true;
}

export default ClipartCollection;
